import { useDispatch } from 'react-redux'
import { Document } from 'services/DocumentService'
import { setSelectedDocuments } from 'redux/actions'
import Icon from 'components/shared/Icon'
import ShareLinks from './ShareLinks'

interface HeaderProps {
  title: string
  selectedDocuments: Document[]
  sectionId: string
}

export default function Header ({ title, selectedDocuments, sectionId }: HeaderProps): JSX.Element {
  const dispatch = useDispatch()

  return (
    <div className='flex items-center justify-between flex-wrap'>
      <h1 className='f3 mv6 grow-2 shrink-0 basis-100-t basis-auto mr4'>
        {title}
      </h1>
      {selectedDocuments.length > 0 && (
        <div
          className='bg-white b--solid b-light-bluish-grey pv3 ph6 flex items-center justify-between flex-wrap grow-1 shrink-1 basis-auto'
        >
          <div className='flex w-100-t'>
            You have selected <strong className='mh2'>{selectedDocuments.length}</strong> document{selectedDocuments.length > 1 ? 's' : ''} to share
          </div>
          <ShareLinks
            key={selectedDocuments.length}
            sectionId={sectionId}
            selectedIds={selectedDocuments.map(({ id }) => id)}
          />
          <button
            className='precedents-blue bg-white hover-bg-ghost-white flex justify-center items-center pointer'
            onClick={() => dispatch(setSelectedDocuments([]))}
          >
            <Icon className='w7 hs7 mr2' name='icon-close-box-outline' />
            Deselect all
          </button>
        </div>
      )}
    </div>
  )
}
